import React from "react";
import MissedSalesContainer from "../containers/MissedSalesContainer";

export const MissedSalesPage: React.FunctionComponent = () => <MissedSalesContainer />;